export const namespace = 'scheduleReport';

export const ACTION_TYPES = {
  CREATE_CUSTOMIZED_REPORT: `${namespace}/CREATE_CUSTOMIZED_REPORT`,
  UPDATE_CUSTOMIZED_REPORT: `${namespace}/UPDATE_CUSTOMIZED_REPORT`,
  GET_SCHEDULE_REPORTS_SAGA: `${namespace}/GET_SCHEDULE_REPORTS_SAGA`,
  SET_SCHEDULE_REPORTS: `${namespace}/SET_SCHEDULE_REPORTS`,
  ADD_SCHEDULE_REPORT: `${namespace}/ADD_SCHEDULE_REPORT`,
  CREATE_SCHEDULE_REPORT_SAGA: `${namespace}/CREATE_SCHEDULE_REPORT_SAGA`,
  UPDATE_SCHEDULE_REPORT_SAGA: `${namespace}/UPDATE_SCHEDULE_REPORT_SAGA`,
  DELETE_REPORT_SAGA: `${namespace}/DELETE_REPORT_SAGA`,
  LOAD_REPORT: `${namespace}/LOAD_REPORT`,
  REMOVE_SCHEDULE_REPORT_SAGA: `${namespace}/REMOVE_SCHEDULE_REPORT_SAGA`,
  MODIFY_REPORT: `${namespace}/MODIFY_REPORT`,
  REMOVE_REPORT: `${namespace}/REMOVE_REPORT`,
  UPDATE_LOADING_STATUS: `${namespace}/UPDATE_LOADING_STATUS`,
  UPDATE_GLOSSARY_REPORT: `${namespace}/UPDATE_GLOSSARY_REPORT`,
};

export const COMPONENTS = {
  LIST: 'LIST',
  SCHEDULE_REPORT_FORM: 'SCHEDULE_REPORT_FORM',
  DELETE_REPORT: 'DELETE_REPORT',
  REPORT: 'REPORT',
}

export const createCustomizedReport = (data) => ({
  type: ACTION_TYPES.CREATE_CUSTOMIZED_REPORT,
  payload: {
    data
  }
});

export const updateCustomizedReport = (data) => ({
  type: ACTION_TYPES.UPDATE_CUSTOMIZED_REPORT,
  payload: {
    data
  }
});

export const updateGlossaryReport = (data) => ({
  type: ACTION_TYPES.UPDATE_GLOSSARY_REPORT,
  payload: {
    data
  }
});

export const getScheduleReports = (query) => ({
  type: ACTION_TYPES.GET_SCHEDULE_REPORTS_SAGA,
  payload: {
    query,
  }
});

export const setScheduleReports = data => ({
  type: ACTION_TYPES.SET_SCHEDULE_REPORTS,
  payload: {
    data
  }
});

export const createScheduleReport = data => ({
  type: ACTION_TYPES.CREATE_SCHEDULE_REPORT_SAGA,
  payload: {
    data
  }
});

export const updateScheduleReport = (scheduleReport, isLayoutUpdated) => ({
  type: ACTION_TYPES.UPDATE_SCHEDULE_REPORT_SAGA,
  payload: {
    scheduleReport,
    isLayoutUpdated
  }
});

export const deleteScheduleReport = (scheduleReport, redirectOption) => {
  return {
  type: ACTION_TYPES.DELETE_REPORT_SAGA,
  payload: {
    scheduleReport,
    redirectOption
  }
}};

export const modifyReports = (action, report, reportId) => ({
  type: action,
  payload: {
    report,
    reportId,
  }
});

export const loadReport = (component, { loading, loaded, reportId, hasError = false }) => ({
  type: ACTION_TYPES.LOAD_REPORT,
  payload: {
    component,
    loading,
    loaded,
    reportId,
    hasError,
  }
});

export const updateLoadingStatus = (component, loadingStatus) => ({
  type: ACTION_TYPES.UPDATE_LOADING_STATUS,
  payload: {
    component,
    loadingStatus,
  }
})
